<template>
  <div class="contentPadding">
    <a-form layout="inline" :model="listQuery" style="margin-bottom:20px;">
      <a-form-item label="合作伙伴名称">
        <a-input
          placeholder="请输入"
          v-model:value="listQuery.key"
          allowClear
        />
      </a-form-item>
      <a-form-item label="合作伙伴类型">
        <a-select
          v-model:value="listQuery.partnerTypeId"
          style="width:194px;"
          allowClear
        >
          <a-select-option
            v-for="(item, index) in partnerTypeArr"
            :key="item.id"
            :value="item.id"
          >
            {{ item.typeName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch"> 查询 </a-button>
      </a-form-item>

      <a-form-item>
        <a-button @click="handleAllReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
      <a-button
        type="primary"
        @click="handleAdd"
        v-if="isShowBtn('sys:syspartner:save')"
        ><PlusOutlined /> 新增
      </a-button>
    </a-row>
    <a-table
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      row-key="id"
      @change="changeTable"
    >
      <a-table-column key="loginName" title="ID" data-index="loginName">
        <template v-slot="scope">
          {{
            (Number(pagination.current) - 1) * Number(pagination.pageSize) +
              scope.index +
              1
          }}
        </template>
      </a-table-column>
      <a-table-column
        key="partnerName"
        title="合作伙伴名称"
        data-index="partnerName"
      />
      <a-table-column
        key="partnerTypeName"
        title="合作伙伴分类"
        data-index="partnerTypeName"
      />
      <a-table-column key="orderNumber" title="排序" data-index="orderNumber" />
      <a-table-column
        key="createTime"
        title="创建时间"
        data-index="createTime"
      />
      <a-table-column key="action" title="操作" width="220px">
        <template v-slot="scope">
          <span>
            <a-button type="link" @click="handleShow(scope.record)">
              查看
            </a-button>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('sys:syspartner:update')"
            >
              修改
            </a-button>
            <a-button
              type="link"
              @click="handleDel(scope.record)"
              v-if="isShowBtn('sys:syspartner:delete')"
            >
              删除
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加、修改modal -->
    <a-modal
      :title="title"
      v-model:visible="showModal"
      :maskClosable="false"
      :footer="null"
      :centered="true"
      width="500px"
    >
      <a-form
        :labelCol="{ span: 8, offset: 0 }"
        :wrapperCol="{ span: 12, offset: 0 }"
        ref="addForm"
        :model="partnerInfo"
        :rules="rules"
      >
        <a-form-item label="合作伙伴名称" name="partnerName">
          <a-input v-model:value="partnerInfo.partnerName" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="合作伙伴类型" name="partnerTypeId">
          <a-select
            v-model:value="partnerInfo.partnerTypeId"
            @change="selectType"
            :disabled="isShow"
          >
            <a-select-option
              v-for="(item, index) in partnerTypeArr"
              :key="item.id"
              :value="item.id"
            >
              {{ item.typeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="合作伙伴LOGO" name="ossUrl" ref="ossUrlRef">
          <div class="clearfix">
            <a-upload
              list-type="picture-card"
              :file-list="imgUrl"
              :customRequest="customRequestZip"
              :before-upload="beforeUploadZip"
              @preview="handlePreview"
              :disabled="isShow"
              :remove="removeFile"
            >
              <div v-if="imgUrl !== null && imgUrl.length < 1">
                <plus-outlined />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="imgVisible"
              :footer="null"
              :keyboard="true"
              :maskClosable="true"
              @cancel="showImg"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-item>
        <a-form-item label="排序" name="orderNumber">
          <a-input-number
            :disabled="isShow"
            id="inputNumber"
            v-model:value="partnerInfo.orderNumber"
            :min="1"
            :max="100000"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 9 }">
          <a-button type="primary" @click="handleSave" v-if="!isShow">
            保存
          </a-button>
          <a-button
            style="margin-left: 10px;"
            @click="handleCancle"
            v-if="!isShow"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="handleCancle"
            v-if="isShow"
          >
            关闭
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal, notification } from "ant-design-vue";
import { isShowBtn } from "@/until/tool";
export default {
  data() {
    const partnerTypeId = async (rule, value) => {
      if (value === "" || !value) {
        return Promise.reject("请选择合作伙伴类型");
      } else {
        return Promise.resolve();
      }
    };
    return {
      title: "",
      rules: {
        ossUrl: [
          { required: true, message: "请选择图片上传", trigger: "change" }
        ],
        partnerName: [
          { required: true, message: "请输入合作伙伴", trigger: "blur" }
        ],
        partnerTypeId: [
          { required: true, validator: partnerTypeId, trigger: "change" }
        ]
      },
      showModal: false, //添加、修改modal的flag
      roleList: [], //角色列表
      data: [], //列表数据
      loading: false,
      selectRowIds: "", //被选中都行
      isShow: false, //是否查看
      pagination: {
        // 分页配置器
        pageSize: 10, // 一页的数据限制
        current: 1, // 当前页
        total: 0, // 总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变 pageSize
        pageSizeOptions: ["5", "10", "30"] // 指定每页可以显示多少条
        // onShowSizeChange: (current, pagesize) => { // 改变 pageSize时的回调
        //   this.pagination.current = current
        //   this.pagination.pageSize = pagesize
        //   ....
        // },
        // onChange: (current) => { // 切换分页时的回调，
        // 当在页面定义change事件时，切记要把此处的事件清除，因为这两个事件重叠了，可能到时候会导致一些莫名的bug
        //   this.pagination.current = current
        // },
        // showTotal: total => `总数：${total}人` // 可以展示总数
      },
      //   ////////////////////////////////////
      imgCode: "",
      partnerTypeArr: [],
      partnerInfo: {
        id: "",
        orderNumber: 1,
        attachmentCode: "",
        ossUrl: "",
        partnerName: "",
        partnerTypeId: null,
        partnerTypeName: ""
      }, //合作伙伴信息对象
      imgUrl: [],
      acceptTypeEquipZip: ["jpg", "jpeg", "png", "gif"],
      imgVisible: false,
      previewImage: "",
      fileImgList: [],
      listQuery: {
        pageSize: 10,
        pageIndex: 1,
        key: "",
        partnerTypeId: ""
      }
    };
  },
  created() {
    this.getRoleList();
  },
  mounted() {
    this.getList();
    this.getPartnerType();
  },
  computed: {
    // 判断选择了哪行数据
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRowIds = selectedRowKeys;
        }
      };
    }
  },
  methods: {
    // 判断按钮权限
    isShowBtn,
    // 上传 zip
    customRequestZip(data) {
      this.showUploadMessage = true;
      this.uploadLoadingFlag = true;
      this.secModalFlag = true;
      const formData = new FormData();
      formData.append("file", data.file);
      if (this.partnerInfo.id) {
        formData.append("attachmentCode", this.partnerInfo.attachmentCode);
      } else {
        formData.append("attachmentCode", this.imgCode);
      }
      formData.append("readType", "public");
      // formData.append("token", "aiufpaidfupipiu"); //随便写一个token示例
      this.$store
        .dispatch("news/UploadAttachment", formData)
        .then(res => {
          if (res.code === 0) {
            // notification["success"]({
            //   message: "上传成功"
            // });
            // res.data.forEach(item => {
            //   item.url = item.ossUrl;
            // });
            res.data.name = res.data.attachmentName;
            res.data.url = res.data.ossUrl;
            this.imgUrl = [res.data];
            this.uploadMessage = res.msg;
            this.uploadSuccessFlag = "1";
            this.partnerInfo.ossUrl = res.data.ossUrl;
            this.$refs.ossUrlRef.clearValidate();
          } else {
            this.uploadMessage = res.msg;
            this.$message.error("上传失败");
            this.uploadSuccessFlag = "0";
          }
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
        })
        .catch(err => {
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
          this.$message.error("调用接口失败，请联系管理员" + err);
        });
    },
    // 文件上传前的格式验证 zip
    beforeUploadZip(file) {
      this.fileImgList = [...this.fileImgList, file];
      const uploadSize = file.size / 1024 / 1024 < 50;
      const uploadType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (
        this.acceptTypeEquipZip.length > 0 &&
        this.acceptTypeEquipZip.indexOf(uploadType) === -1
      ) {
        this.$message.error(
          "导入文件只能是" + this.acceptTypeEquipZip.join("、") + "格式!"
        );
        return false;
      }
      if (!uploadSize) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return false;
      }
    },
    // 删除上传文件
    removeFile(file) {
      console.log(this.imgUrl, "imgUrl");
      this.removeAttach(this.imgUrl[0]);
      this.imgUrl = [];
    },
    // 删除图片
    removeAttach(data) {
      this.$store
        .dispatch("news/DeleteAttachment", data.id)
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "删除成功"
            });
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 预览图片
    handlePreview() {
      this.imgVisible = true;
      this.previewImage = this.imgUrl[0].ossUrl;
    },
    // 获取客户类型
    getPartnerType() {
      this.$store
        .dispatch("SelectListPartnerType", { key: "" })
        .then(res => {
          if (res.code === 0) {
            this.partnerTypeArr = res.data;
            console.log(this.partnerTypeArr, "partner...");
          } else {
            this.$$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 选择合作伙伴类型
    selectType(e) {
      this.partnerTypeArr.forEach(item => {
        if (item.id === e) {
          this.partnerInfo.partnerTypeName = item.typeName;
        }
      });
    },
    // 添加列表图片时获取code
    getAddListImgCode() {
      this.$store
        .dispatch("news/GetAttachmentCode")
        .then(res => {
          this.imgCode = res;
          this.partnerInfo.attachmentCode = res;
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 新增
    handleAdd() {
      this.title = "新增合作伙伴信息";
      this.isShow = false;
      this.showModal = true;
      this.imgUrl = [];
      this.temp();
      this.getAddListImgCode();
    },
    showImg() {
      this.imgVisible = false;
    },
    // 保存用户信息
    handleSave() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const partnerObj = Object.assign(self.partnerInfo);
      let funStr = "";
      let msg = "";
      if (partnerObj.id === "") {
        funStr = "SavePartner";
        msg = "添加成功";
      } else {
        funStr = "UpdatePartner";
        msg = "修改成功";
      }
      this.$refs.addForm
        .validate()
        .then(() => {
          self.$store
            .dispatch(funStr, self.partnerInfo)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: msg
                });
                this.showModal = false;
                this.temp();
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    //情况添加数据
    temp() {
      this.partnerInfo = {
        id: "",
        orderNumber: 1,
        attachmentCode: "",
        ossUrl: "",
        partnerName: "",
        partnerTypeId: null,
        partnerTypeName: ""
      };
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("ListPartner", this.listQuery)
        .then(res => {
          if (res.code === 0) {
            if (
              res.data.currPage > res.data.totalPage &&
              res.data.totalPage !== 0
            ) {
              this.listQuery.pageIndex = res.data.totalPage;
              this.getList();
            } else {
              this.listQuery.pageIndex = res.data.currPage;
            }
            this.data = res.data.list;
            this.listQuery.pageSize = res.data.pageSize;
            this.pagination.current = res.data.currPage;
            this.pagination.pageSize = res.data.pageSize;
            this.pagination.total = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            // this.$message.error(res.msg);
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 查询
    handleSearch() {
      this.listQuery.pageIndex = "1";
      this.listQuery.pageSize = this.pagination.pageSize;
      this.getList();
    },
    handleAllReset() {
      this.listQuery = {
        pageSize: 10,
        pageIndex: 1,
        key: "",
        partnerTypeId: ""
      };
    },
    // 删除
    handleDel(rowData) {
      this.$store
        .dispatch("DeletePartner", [rowData.id])
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "删除成功"
            });
            this.getList();
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 修改
    handleEdit(rowData) {
      this.title = "修改合作伙伴信息";
      this.isShow = false;
      this.showModal = true;
      this.$store
        .dispatch("InfoPartner", { id: rowData.id })
        .then(res => {
          if (res.code === 0) {
            let obj = {};
            obj = Object.assign({}, res.sysPartner);
            this.$store
              .dispatch("news/GetAttachmentList", {
                attachmentCode: obj.attachmentCode
              })
              .then(re => {
                if (re.data) {
                  if (re.data.length > 0) {
                    const imgObj = re.data[0];
                    imgObj.url = imgObj.ossUrl;
                    if (!imgObj.url) {
                      this.imgUrl = [];
                    } else {
                      this.imgUrl = [imgObj];
                    }
                  }
                }
              })
              .catch(er => {
                this.$handleErr(er);
              });
            // this.imgUrl = [obj];
            this.partnerInfo = obj;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 查看
    handleShow(rowData) {
      console.log('....ssdfs')
      this.title = "合作伙伴信息";
      this.isShow = true;
      this.showModal = true;
      this.$store
        .dispatch("InfoPartner", { id: rowData.id })
        .then(res => {
          if (res.code === 0) {
            let obj = {};
            obj = Object.assign({}, res.sysPartner);
            obj.url = res.sysPartner.ossUrl;
            if (!obj.url) {
              this.imgUrl = [];
            } else {
              this.imgUrl = [obj];
            }
            this.partnerInfo = obj;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    ///////////////////////////////////////

    // 获取所有角色列表
    getRoleList() {
      this.$store
        .dispatch("SelecRoletList")
        .then(res => {
          if (res.code === 0) {
            this.roleList = res.data;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },

    // 取消
    handleCancle() {
      this.showModal = false;
      this.$refs.addForm.resetFields();
      this.temp();
    },

    // 删除多条数据
    handleAllDel() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      if (this.selectRowIds.length === 0) {
        this.$message.warning("请先选择数据，在进行批量删除操作");
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认批量删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteUserBatchById", self.selectRowIds.join(","))
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.selectRowIds = "";
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        },
        onCancel() {
          console.log("...");
        }
      });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.listQuery.pageIndex = pagination.current;
      this.listQuery.pageSize = pagination.pageSize;
      this.getList();
    }
  }
};
</script>
<style scoped></style>
